import PrinterSettingsView from './PrinterSettingsView';

export default {
  PrinterSettingsView,
};
